module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "l-header"
  }, [_c('a', {
    staticClass: "ff-logo",
    attrs: {
      "href": "http://www.filzfelt.com"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "filzfelt",
      "src": require("../../assets/logo-ff.png"),
      "width": "179",
      "height": "44"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--portfolio is-first",
    attrs: {
      "href": "https://www.filzfelt.com/portfolio/categories/"
    }
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--products",
    attrs: {
      "href": "https://www.filzfelt.com/products/categories/"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--design-tool",
    attrs: {
      "href": "http://dt.filzfelt.com/"
    }
  }, [_vm._v("Design Tool")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--about",
    attrs: {
      "href": "https://www.filzfelt.com/about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item--shop",
    attrs: {
      "href": "https://www.filzfelt.com/shop/categories/"
    }
  }, [_vm._v("Shop")]), _vm._v(" "), _c('form', {
    staticClass: "site-search-form",
    attrs: {
      "method": "post",
      "action": "https://www.filzfelt.com/index.php"
    }
  }, [_c('div', {
    staticClass: "hiddenFields"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "ACT",
      "value": "4"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "RES",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "meta",
      "value": "cUhAUc7Z0E6+4Wq3A5LDgE6tzuuGAEkpJY+ZNQQ/nDj0ElAryylRoBAtY27hWM4/zgJWQLtiMUav6nHWOHCp4SRfsb5rAZktzylT/jZOE+HYA7PifK/s4q+brfPzL7A4Q+PIrsdXN0ClMlKLk/bQQmT7oYbFu/VVzBxnoS4OtidHPEryxzjuXAGF/jPR4Rym3IvZpESdJHUUxwHz90rdUscu1YjbHpu+tDEzNkyq8/bfFzc7Ev2IHEmpXi4bv7eXHrKhGhvPjkE6wGoqXl4wkmiXjqVMmdLnoholaoIW7hFI4JPWMxGwuWSzpT+Cnu9+8U9F6b+PGmhjmqhkrIX2vPRi9L1nynq1gHPv3pisLXR2bgCUO/1b9tPlyowFNyxc4cckE9xsQtPXXJypiBNz36e6fBZJf/2wWR4LaRZn3QdIRYLqVYRMWmrD8YZR7O4Z5apKEIh/waFLUDfToHSvsyg7maS+upb2mJZpSGUZl9c9WfHQU7T9LTTzXG9VMJgL"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "site_id",
      "value": "1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "csrf_token",
      "value": "1c09d6803e7d32e7b86d01c6b88698079e8ef5c4"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "input-text site-search-form__input",
    attrs: {
      "name": "keywords",
      "id": "keywords",
      "type": "text",
      "placeholder": "Search…"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "site-search-form__submit",
    attrs: {
      "type": "submit"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57b811ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/wrappers/HeaderFilzfelt.vue
// module id = 569
// module chunks = 1